export default "__VITE_ASSET__e3d6bec7__"